<script>
export default {
  name: "PlatformStatement"
}
</script>

<template>
  <section class="platform-statement">
    <div class="responsive-rows">
      <article class="article-body">
        <header>
          <h2 class="article-title mb-2">One Platform Across the Full Therapy Arc</h2>
<!--          <h3 class="article-subtitle">-->
<!--            We’ve had a lot of help!-->
<!--          </h3>-->
        </header>
        <p class="mt-4 is-size-5">
          OVB supports vision therapy from early skill development through functional carryover and long-term visual efficiency without disrupting continuity or requiring a platform switch.
        </p>
      </article>
    </div>
  </section>
</template>

<style scoped lang="scss">
.platform-statement {}
</style>